export const peopleTitles = ['Name', 'Sex', 'Born', 'Died'];
